import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    { path: "/", name: "form", component: () => import("@/views/form.vue") },
    {
      path: "/thanks",
      name: "thankyou",
      component: () => import("@/views/thanks.vue"),
    },
    {
      path: "/login",
      name: "userLogin",
      component: () => import("@/views/userLogin.vue"),
    },
    {
      path: "/report",
      name: "report",
      component: () => import("@/views/report.vue"),
      meta: { requiresAuthReport: true },
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: () => import("@/views/dashboard.vue"),
    },
    {
      path: "/admin",
      name: "admin",
      component: () => import("@/views/admin.vue"),
    },
  ],
});



export default router;
